var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350)",
    d: "m0 0h1341l1 2 37 9 30 9 34 13 24 11 26 14 33 22 13 10 10 8 11 10 8 7 22 22 18 22 13 18 14 21 12 21 11 22 10 24 11 29 10 35 7 28h2v1364h-2v-3l-3-1 2-5h-3v5l-3-2-7 26-6 19-7 19-9 22-9 17-6 13-12 20-20 30-13 16-12 14-29 29-22 18-16 12-17 11-26 15-28 14-36 14-30 10-52 13v1h-1322l1-2-41-11-38-11-21-8-26-11-29-15-24-16-11-8-18-14-14-12-13-12-14-14-7-8-13-15-15-20-14-21-13-22-14-28-12-30-9-27-10-38-1-2-1-10-3-4v-1342l2 4 1-5h2l2-11 10-36 11-33 8-19 17-34 10-16 7-11 13-19 11-14 8-10h2l2-4 16-17 12-12 8-7 10-9 12-9 10-8 15-10 18-11 16-9 15-8 28-12 28-10 18-5 25-6 14-3 1-1zm562 119-487 1-42 2-23 3-23 5-23 8-26 11-23 13-14 9-16 12-13 11-28 28-11 14-8 10-12 19-14 26-10 23-7 19-6 23-3 17-2 24-1 25v1205l2 33 3 25 6 25 7 20 8 20 11 22 11 18 13 18 11 14 12 13 12 12 11 9 13 11 18 12 24 14 25 12 25 9 24 6 27 4 39 3 29 1h1133l48-1 30-2 25-4 23-6 20-7 25-10 19-10 15-9 19-13 13-11 10-8 18-18 9-11 14-17 11-17 12-22 9-19 10-28 5-19 5-32 2-32v-1215l-1-25-3-24-6-28-5-16-10-26-8-16-10-19-14-21-10-13-11-13-11-12-8-7-10-9-16-12-17-11-21-12-24-11-19-7-22-7-22-4-17-2-45-2-476-1zm-911 234 1 3zm2042 1356m-4 2 1 3z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(909,419)",
    d: "m0 0h26l18 4 16 7 12 8 7 5v2l4 2 7 8 10 13 11 19 2 3h3l8-14 8-12 14-17 11-9 14-9 14-6 13-3 6-1h24l16 3 13 5 15 8 13 11 5 5 7 8 8 13 7 15 5 19 1 7v12l-3 17-6 16-11 23-6 10-6 11-14 24-11 19-12 21-15 26-10 17-11 19-9 15-6 11-10 18-13 22-24 42-10 17-8 14-10 17-13 23-28 48-13 23-10 17-7 12-6 11-14 24-11 19-13 22-5 9-10 17-13 23-10 17-7 12h209l8 7 11 18 7 13 16 27 22 38 12 22 8 13 15 26 9 16 6 9 5 10v3l-2 1h-734l-32-1-15-2-18-6-12-7-10-8-13-13-10-15-6-12-6-18-2-12v-14l4-19 6-15 6-12 8-11 9-10 9-7 14-9 15-6 14-3 7-1 40-1h161l6-3 14-22 14-25 22-38 14-24 11-19 14-24 12-21 11-19 8-13 6-11 9-16 12-21 13-22 12-21 11-19 14-24 14-25 13-22 9-16 12-21 16-29 6-8-1-7-13-22-15-26-14-24-15-26-12-22-9-19-6-18-1-5v-21l4-17 6-15 7-12 11-14 5-5 13-11 10-6 14-6z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,777)",
    d: "m0 0 5 2 9 16 13 25 8 14 13 22 15 25 11 19 15 26 13 23 14 24 11 19 14 24 11 20 10 17 15 26 15 25 6 11 12 21 11 18 6 8h156l46 1 22 4 15 6 13 8 11 9 8 8 11 16 8 17 4 13 2 13v15l-4 18-7 16-6 11-8 11-3 4h-2l-2 4-4 2v2l-13 9-13 6-18 5-18 3-33 2h-48l1 5 10 16 12 21 14 24 15 26 12 23 7 17 4 13 1 5v24l-4 17-7 16-8 14-9 11-10 10-10 6-15 7-19 6-6 1h-28l-14-3-13-5-11-6-11-9-12-12-11-15-9-15-17-29-13-22-28-49-15-26-12-21-14-24-15-26-16-28-10-17-14-24-15-26-16-28-15-26-10-17-15-26-16-28-15-26-14-24-26-46-12-21-13-23-13-22-3-7 5-12 7-11 11-20 11-18 16-28 9-15 12-21 11-19 10-17 6-10 8-16 6-10z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,1442)",
    d: "m0 0 98 1h125l2 2-9 14-10 16-6 12-10 18-13 23-10 18-12 20-7 11-8 11-10 12h-2l-2 4-11 8-20 9-16 5-6 1h-25l-18-4-13-5-14-8-15-13-11-14-9-16-5-14-3-13-1-12 3-21 5-16 7-16 12-22 8-9z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1715)",
    d: "m0 0h8l1 3-3 1-6-2z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,2045)",
    d: "m0 0 5 1 3 2h-9z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341)",
    d: "m0 0h5v3l-5 1-1-2z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,324)",
    d: "m0 0 1 3h-2z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(347)",
    d: "m0 0 2 1-2 2z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(332)",
    d: "m0 0 4 1z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,328)",
    d: "m0 0",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1683,2047)",
    d: "m0 0",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1167,804)",
    d: "m0 0",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1179,781)",
    d: "m0 0",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,339)",
    d: "m0 0",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1711)",
    d: "m0 0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.d27135cdb7828170a2f0eda5e915fe8c.svg";
export { ForwardRef as ReactComponent };